import { memo } from 'react';
import { AlertBanner } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { useInviteMember } from '../../hooks/useInviteMember';
import EmailsField from './EmailsField';
import NameField from './NameField';
import UploadInsteadPrompt from './UploadInsteadPrompt';
import UserTypeCards from './UserTypeCards';

/**
 * People step: emails (chips), optional names, user type and the bulk-upload prompt.
 */
function PeopleStep() {
  const { t } = useTranslation('people-access');
  const {
    state,
    lookupFailed,
    addEmails,
    setDraft,
    removeEmail,
    correctInvalid,
    removeInvalid,
    removeExisting,
    setName,
    setUserType,
  } = useInviteMember();

  return (
    <div className="flex flex-col gap-6">
      <EmailsField
        emails={state.emails}
        draft={state.draft}
        onDraftChange={setDraft}
        invalid={state.invalid}
        existing={state.existing}
        onAdd={addEmails}
        onRemove={removeEmail}
        onCorrectInvalid={correctInvalid}
        onRemoveInvalid={removeInvalid}
        onRemoveExisting={removeExisting}
      />

      {lookupFailed && (
        <AlertBanner tone="warning" title={t('invite.people.lookupFailedTitle')}>
          {t('invite.people.lookupFailedBody')}
        </AlertBanner>
      )}

      <UploadInsteadPrompt />

      {state.emails.length > 0 && (
        <section className="flex flex-col gap-2">
          <div>
            <h2 className="m-0 text-sm font-medium text-content-secondary">
              {t('invite.people.namesLabel')}{' '}
              <span className="font-normal text-content-muted">{t('invite.people.optional')}</span>
            </h2>
            <p className="m-0 text-xs text-content-muted">{t('invite.people.namesHelper')}</p>
          </div>
          {state.emails.map((email) => (
            <NameField key={email} email={email} value={state.names[email]} onChange={setName} />
          ))}
        </section>
      )}

      <UserTypeCards value={state.userType} onChange={setUserType} />
    </div>
  );
}

export default memo(PeopleStep);
